<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :edit-rules="editRules"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
<!--        <vxe-button @click="addRow({-->
<!--        catPropId: 0,-->
<!--        goodsPropValueList:[]-->
<!--        })">新增-->
<!--        </vxe-button>-->
<!--        <vxe-button @click="delRow()">删除</vxe-button>-->
      </template>
    </x-grid>

<!--    <a-modal-->
<!--        title="编辑属性值"-->
<!--        centered-->
<!--        :closable="false"-->
<!--        :footer="null"-->
<!--        :maskClosable="false"-->
<!--        :visible="visible"-->
<!--        :width="1000"-->
<!--    >-->
<!--      <categoryTableModal-->
<!--          ref="categoryTableModal"-->
<!--          :rowId="editRowId"-->
<!--          :goodsId="rowId"-->
<!--          @closePop="closePop"-->
<!--      ></categoryTableModal>-->
<!--    </a-modal>-->
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"
// import {loadBaseCodeData} from "@/services/baseCodeSource";
// import {dataApi} from "@/services/clue/clueManage";

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错

//弹出层组件
// import categoryTableModal from "@/pages/web/demo/normalList/detail/categoryTableModal";

//列
const columns = [
  // fac.makeColumnCheckboxDefault(),
  fac.makeColumn({
    field: "custName",
    title: "客户名称",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "custMobile",
    title: "客户电话",
    width: 120,
    align: 'center',
  }),
  fac.makeColumn({
    field: "companyName",
    title: "客户公司",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "custIntention",
    title: "是否有意向",
    width: 100,
    formatter:fmt.formatYesNo,
    align: 'center',
  }),
  fac.makeColumn({
    field: "saleUserName",
    title: "销售顾问",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "wantStrainName",
    title: "意向品系",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "wantBrandName",
    title: "意向品牌",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "nextWantLevelName",
    title: "意向等级",
    width: 180,
    align: 'center',
    // editRender: {
    //   name: '$input',
    //   defaultValue: 1,
    //   props: {
    //     type: 'datetime'
    //   },
    // },
    // editRules: [{required: true}]
  }),
  fac.makeColumn({
    field: "wantCount",
    title: "预购数量(台)",
    width: 120,
    align: 'center',
    // editRender: {
    //   name: '$select',
    //   props: {
    //     options:[]
    //   },
    // },
    // editRules: [{required: true}]
  }),
  fac.makeColumn({
    field: "succAmount",
    title: "成交数量(台)",
    width: 120,
    align: 'center',
  }),

  fac.makeColumn({
    field: "estimateBuyDate",
    title: "预计购车日期",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "customerAttentionName",
    title: "客户关注点",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "reportDesc",
    title: "跟进具体情况",
    width: 160,
    align: 'center',
    // editRender: {
    //   name: 'input',
    // },
    // editRules: [{required: true}]
  }),
  // fac.makeColumn({
  //   field: "reportDesc",
  //   title: "记录内容",
  //   width: 200,
  //   editRender: {
  //     name: '$switch',
  //     defaultValue: 1,
  //     props: {
  //       'open-label': "是",
  //       'close-label': '否',
  //       'open-value': 1,
  //       'close-value': 0,
  //     },
  //   },
  //
  //   // editRules: [{required: true}]
  // }),
  fac.makeColumn({
    field: "dealChanceName",
    title: "成交概率",
    width: 100,
    align: 'center',
    // editRender: {
    //   name: '$select',
    //   defaultValue: 1,
    //   props: {
    //     options:[{label:'123',value:111}]
    //   },
    // },
    // editRules: [{required: true}]
  }),
  fac.makeColumn({
    field: "reportTypeName",
    title: "跟进方式",
    width: 100,
    align: 'center',
  }),
  fac.makeColumn({
    field: "callonDate",
    title: "跟进时间",
    width: 160,
    align: 'center',
    // editRules: [{required: true}]
  }),

  fac.makeColumn({
    field: "reportDesc",
    title: "跟进具体情况",
    width: 160,
    align: 'center',
  }),
  fac.makeColumn({
    field: "needSupportDesc",
    title: "需要支持事项",
    width: 140,
    align: 'center',
    // editRender: {
    //   name: '$select',
    //   // defaultValue: 1,
    //   props: {
    //     options:[{label:'123',value:111}]
    //   },
    // },
    // editRules: [{required: true}]
  }),

  fac.makeColumn({
    field: "nextCallonDate",
    title: "下次跟进时间",
    width: 160,
    align: 'center',
    // editRules: [{required: true}]
  }),
   fac.makeColumn({
    field: "isOverdue",
    title: "是否按时跟进",
    width: 160,
    align: 'center',
    formatter:fmt.formatIsOverdue,
  }),
]

const rowIdName = 'catPropId';

//可编辑表格规则 没有特殊要求的不改
const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

// /**
//  * 加载基础数据
//  */
// async function loadBaseData() {
//   let commCodeData = await dataApi.getCommCode();
//   this.strainOptions = commCodeData.data.strain.map(v => {
//     return {
//       label: v.code_name,
//       value: v.code_id
//     }
//   })
// }

export default {
  mixins: [GridChildMixin],
  components: {
    // categoryTableModal
  },
  data() {
    return {
      rowIdName,
      toolbarConfig,
      editRules,
      columns,
      editConfig,
      editRowId: -1,
      loyalTypeOptions:[]
    }
  },
async mounted() {
    // await this.getLoyal()
},
  methods: {
    // async getLoyal(){
    //   let loyal=await loadBaseCodeData('CD200003')
    //   let loyalType = loyal.map((item)=>{
    //     return{
    //       value:item.codeId,
    //       label:item.codeName
    //     }
    //   })
    //   this.columns[5].editRender.props.options=loyalType
    //
    //   let level=await loadBaseCodeData('CD200002')
    //   let levelType = level.map((item)=>{
    //     return{
    //       value:item.codeId,
    //       label:item.codeName
    //     }
    //   })
    //   this.columns[7].editRender.props.options=levelType
    //
    //   let succ=await loadBaseCodeData('CD200001')
    //   let succType = succ.map((item)=>{
    //     return{
    //       value:item.codeId,
    //       label:item.codeName
    //     }
    //   })
    //   this.columns[8].editRender.props.options=succType
    //
    //   this.columns[7].editRender.props.options=levelType
    //
    //   let report=await loadBaseCodeData('CD200005')
    //   let reportType = report.map((item)=>{
    //     return{
    //       value:item.codeId,
    //       label:item.codeName
    //     }
    //   })
    //   this.columns[3].editRender.props.options=reportType
    // },
    editChild() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      if (!rows[0][rowIdName] && !rows[0]['goodsPropId']) {
        return this.$message.error('该数据未保存，请先保存再编辑');
      }

      this.editRowId = rows[0].goodsPropId;
      this.visible = true;
    },
    closePop() {
      this.editRowId = -1;
      this.visible = false;
    },
    // loadBaseData
  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}
</style>